"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const FiltroBox_vue_1 = __importDefault(require("./FiltroBox.vue"));
let FiltrosAplicados = class FiltrosAplicados extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.params = this.value;
    }
    get aplicados() {
        let aplicados = [];
        if (lodash_1.default.has(this.params, "estado")) {
            let filtro = lodash_1.default.find(this.filtros.estados, ["id", this.params.estado]);
            if (filtro) {
                aplicados.push({
                    key: "estado",
                    label: "Estado",
                    value: filtro.nombre,
                    default: 0,
                });
            }
        }
        if (lodash_1.default.has(this.params, "barrios")) {
            if (this.params.barrios.length) {
                let nombres = [];
                this.params.barrios.forEach((value) => {
                    this.filtros.ciudades.forEach((ciudad) => {
                        let filtro = lodash_1.default.find(ciudad.barrios, ["id", value]);
                        if (filtro) {
                            nombres.push(filtro.nombre);
                        }
                    });
                });
                if (nombres.length) {
                    if (nombres.length > 2) {
                        aplicados.push({
                            key: "barrios",
                            label: "Barrios",
                            value: nombres.length + ` Opciones`,
                            default: [],
                        });
                    }
                    else {
                        aplicados.push({
                            key: "barrios",
                            label: nombres.length === 1 ? "Barrio" : "Barrios",
                            value: nombres.join(", "),
                            default: [],
                        });
                    }
                }
            }
        }
        if (lodash_1.default.has(this.params, "areas")) {
            if (this.params.areas.length) {
                let nombres = [];
                this.params.areas.forEach((value) => {
                    let filtro = lodash_1.default.find(this.filtros.areas, ["id", value]);
                    if (filtro) {
                        nombres.push(filtro.nombre);
                    }
                });
                if (nombres.length) {
                    if (nombres.length > 2) {
                        aplicados.push({
                            key: "areas",
                            label: "Areas",
                            value: nombres.length + ` Opciones`,
                            default: [],
                        });
                    }
                    else {
                        aplicados.push({
                            key: "areas",
                            label: "Areas",
                            value: nombres.join(", "),
                            default: [],
                        });
                    }
                }
            }
        }
        if (lodash_1.default.has(this.params, "prestaciones")) {
            if (this.params.prestaciones.length) {
                let nombres = [];
                this.params.prestaciones.forEach((value) => {
                    let filtro = lodash_1.default.find(this.filtros.prestaciones, ["id", value]);
                    if (filtro) {
                        nombres.push(filtro.nombre);
                    }
                });
                if (nombres.length) {
                    if (nombres.length > 2) {
                        aplicados.push({
                            key: "prestaciones",
                            label: "Prestaciones",
                            value: nombres.length + ` Opciones`,
                            default: [],
                        });
                    }
                    else {
                        aplicados.push({
                            key: "prestaciones",
                            label: "Prestaciones",
                            value: nombres.join(", "),
                            default: [],
                        });
                    }
                }
            }
        }
        if (!lodash_1.default.isEqual(this.params.antiguedad, this.filtros.antiguedad)) {
            aplicados.push({
                key: "antiguedad",
                label: "Antiguedad",
                value: `${this.params.antiguedad[0]} - ${this.params.antiguedad[1]} A&ntilde;os`,
                default: this.filtros.antiguedad,
            });
        }
        if (lodash_1.default.has(this.params, "ambientes")) {
            if (this.params.ambientes.length) {
                aplicados.push({
                    key: "ambientes",
                    label: "Ambientes",
                    value: this.params.ambientes.join(", "),
                    default: [],
                });
            }
        }
        if (!lodash_1.default.isEqual(this.params.precio, this.filtros.precio)) {
            let precio_min = this.params.precio[0].toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
            });
            let precio_max = this.params.precio[1].toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
            });
            aplicados.push({
                key: "precio",
                label: "Precio",
                value: `${precio_min} - ${precio_max}`,
                default: this.filtros.precio,
            });
        }
        if (!lodash_1.default.isEqual(this.params.superficie_total, this.filtros.superficie_total)) {
            aplicados.push({
                key: "superficie_total",
                label: "Sup. Total",
                value: `${this.params.superficie_total[0]} m&sup2; - $${this.params.superficie_total[1]} m&sup2;`,
                default: this.filtros.superficie_total,
            });
        }
        if (!lodash_1.default.isEqual(this.params.superficie_cubierta, this.filtros.superficie_cubierta)) {
            aplicados.push({
                key: "superficie_cubierta",
                label: "Sup. Cubierta",
                value: `${this.params.superficie_cubierta[0]} m&sup2; - ${this.params.superficie_cubierta[1]} m&sup2;`,
                default: this.filtros.superficie_cubierta,
            });
        }
        if (lodash_1.default.has(this.params, "cochera")) {
            if (this.params.cochera) {
                aplicados.push({
                    key: "cochera",
                    label: "Con Cochera",
                    value: false,
                    default: false,
                });
            }
        }
        if (lodash_1.default.has(this.params, "profesional")) {
            if (this.params.profesional) {
                aplicados.push({
                    key: "profesional",
                    label: "Apto Profesional",
                    value: false,
                    default: false,
                });
            }
        }
        if (lodash_1.default.has(this.params, "favoritos")) {
            if (this.params.favoritos) {
                aplicados.push({
                    key: "favoritos",
                    label: "Favoritos",
                    value: false,
                    default: false,
                });
            }
        }
        return aplicados;
    }
    get total() {
        return this.aplicados.length;
    }
    reset(key, value) {
        if (typeof key === "object" && key.length) {
            if (typeof value === "object") {
                let i = 0;
                key.forEach((id) => {
                    this.params[id] = value[i];
                    i++;
                });
            }
            else {
                key.forEach((id) => {
                    this.params[id] = value;
                });
            }
        }
        else if (typeof key === "string") {
            this.params[key] = value;
        }
    }
    onParamsChanged() {
        this.$emit("input", this.params);
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], FiltrosAplicados.prototype, "value", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], FiltrosAplicados.prototype, "filtros", void 0);
__decorate([
    vue_property_decorator_1.Watch("params"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAplicados.prototype, "onParamsChanged", null);
FiltrosAplicados = __decorate([
    vue_property_decorator_1.Component({ components: { FiltroBox: FiltroBox_vue_1.default } })
], FiltrosAplicados);
exports.default = FiltrosAplicados;
